import { DynamicField, DynamicForm, FieldVariant, NumberFieldProps, TextFieldProps } from '@/components/form-builder/form-builder.types';
import { CurrencyRepository } from '@/store/currency-state/currency-state.repository';

interface IgetCurrencyFormObjectProps {
  store: CurrencyRepository;
}

export const getCurrencyFormObject = ({ store }: IgetCurrencyFormObjectProps): DynamicForm => {
  const codeField: DynamicField<TextFieldProps> = {
    label: 'settings.currency.form.code.label',
    variant: FieldVariant.TEXT,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'code'),
    props: {
      value: store.getNestedObservable<string>('dto', 'code'),
      onChange: (value: string) => {
        store.setNestedWithComparison('dto', 'code', value);
        store.setNested('errors', 'code', '');
      },
    },
  };
  const descriptionField: DynamicField<TextFieldProps> = {
    label: 'settings.currency.form.description.label',
    variant: FieldVariant.TEXT,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'description'),
    props: {
      value: store.getNestedObservable<string>('dto', 'description'),
      onChange: (value: string) => {
        store.setNestedWithComparison('dto', 'description', value);
        store.setNested('errors', 'description', '');
      },
    },
  };

  const tauxField: DynamicField<NumberFieldProps> = {
    label: 'settings.currency.form.taux.label',
    variant: FieldVariant.NUMBER,
    isRequired: true,
    error: store.getNestedObservable<string>('errors', 'taux'),
    props: {
      mode: 'decimal',
      maxFractionDigits: 3,
      min: 0.001,
      value: store.getNestedObservable<number>('dto', 'taux'),
      onChange: (value: number) => {
        store.setNestedWithComparison('dto', 'taux', value);
        store.setNested('errors', 'taux', '');
      },
    },
  };

  return {
    title: 'settings.currency.form.title',
    description: '',
    isHeaderHidden: true,
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [codeField],
          },
          {
            fields: [descriptionField],
          },
          {
            fields: [tauxField],
          },
        ],
      },
    ],
  };
};
